import React, { useEffect } from "react";
import Navigation from "./components/Navigation/Navigation";
import AOS from "aos";
import "aos/dist/aos.css";
import "./style.scss";
import { Route, Routes, useLocation } from "react-router-dom";
import Team from "./pages/Team/Team";
import NotFound from "./pages/NotFound/NotFound";
import Contact from "./pages/Contact/Contact";
import Header from "./components/Header/Header";
import { allowFooter, allowHeader } from "./utils";
import Home from "./pages/Home/Home";
import About from "./pages/About/About";
import Footer from "./components/Footer/Footer";
import Apply from "./pages/Apply/Apply";
import AddMemberDetails from "./pages/Forms/AddMemberDetails/AddMemberDetails";
import Events from "./pages/Events/Events";
import GlobalContext from "./context/GlobalContext";
import { useContextData } from "./context/useContext";
import Login from "./pages/Login/Login";
import Admin from "./pages/Admin/Admin";
import PrivateRoute from "./components/PrivateRoute";
import Members from "./pages/Members/Members";
import Write from "./pages/Write/Write";
import Logout from "./pages/Logout";
import Applications from "./pages/Applications/Applications";
import Gallery from "./pages/Gallery/Gallery";
import Alumni from "./pages/NotableAlumni/Alumni";

const Wrapper = () => {
	AOS.init();
	const location = useLocation();
	useEffect(() => {
		window.scrollTo(0, 0);
	}, [location.pathname]);
	return (
		<>
			{allowHeader(location.pathname) && <Header />}
			<Navigation />
			<Routes>
				<Route path="/" element={<Home />} />
				<Route path="/about" element={<About />} />
				<Route path="/login" element={<Login />} />
				<Route path="/logout" element={<Logout />} />
				<Route
					path="/admin"
					element={
						<PrivateRoute>
							<Admin />
						</PrivateRoute>
					}
				/>
				<Route
					path="/admin/applications"
					element={
						<PrivateRoute>
							<Applications />
						</PrivateRoute>
					}
				/>
				<Route
					path="/admin/members"
					element={
						<PrivateRoute>
							<Members />
						</PrivateRoute>
					}
				/>
				<Route
					path="/admin/write"
					element={
						<PrivateRoute>
							<Write />
						</PrivateRoute>
					}
				/>
				<Route path="/events" element={<Events />} />
				<Route path="/forms/apply" element={<Apply />} />
				<Route path="/team" element={<Team />} />
				<Route path="/gallery" element={<Gallery />} />
				<Route path="/contact" element={<Contact />} />
				<Route
					path="/forms/add-member-details"
					element={<AddMemberDetails />}
				/>
				<Route path="/notable-alumni" element={<Alumni />} />
				<Route path="*" element={<NotFound />} />
			</Routes>
			{allowFooter(location.pathname) && <Footer />}
		</>
	);
};

const App = () => {
	const context = useContextData();
	return (
		<GlobalContext.Provider value={context}>
			<Wrapper />
		</GlobalContext.Provider>
	);
};

export default App;
